import { render, staticRenderFns } from "./CardProjectActions.vue?vue&type=template&id=a5addb64&scoped=true"
import script from "./CardProjectActions.vue?vue&type=script&lang=js"
export * from "./CardProjectActions.vue?vue&type=script&lang=js"
import style0 from "./CardProjectActions.vue?vue&type=style&index=0&id=a5addb64&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5addb64",
  null
  
)

export default component.exports